const e=3,t="reset-cell-padding";export{t as RESET_CELLS_PADDING_CLASSNAME,e as TRAILING_SHIMMER_ROWS};
//# sourceMappingURL=ShimmeredDetailsList.types.js.map
